import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function AlertDialog(props) {
  const { t } = useTranslation();
  const {
    open,
    onClose,
    children,
    title,
    message,
    onConfirm,
    confirmText,
    cancelText,
    type = 'info', // 'info', 'warning', 'error', 'success'
    severity = 'medium' // 'low', 'medium', 'high'
  } = props;

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return <WarningIcon style={{ color: '#ff9800', fontSize: 48 }} />;
      case 'error':
        return <ErrorIcon style={{ color: '#f44336', fontSize: 48 }} />;
      case 'success':
        return <CheckCircleIcon style={{ color: '#4caf50', fontSize: 48 }} />;
      default:
        return <InfoIcon style={{ color: colors.MAIN_COLOR, fontSize: 48 }} />;
    }
  };

  const getConfirmButtonColor = () => {
    switch (severity) {
      case 'high':
        return '#f44336'; // Red for dangerous actions
      case 'medium':
        return '#ff9800'; // Orange for medium risk
      default:
        return colors.MAIN_COLOR; // Blue for low risk
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 12,
          padding: 8
        }
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{
          paddingBottom: 8,
          display: 'flex',
          alignItems: 'center',
          gap: 12
        }}
      >
        {getIcon()}
        <span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
          {title || "Alert"}
        </span>
      </DialogTitle>

      <DialogContent style={{ paddingTop: 8 }}>
        <DialogContentText
          id="alert-dialog-description"
          style={{
            fontSize: '1rem',
            color: '#333',
            lineHeight: 1.6
          }}
        >
          {message || children}
        </DialogContentText>
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px 24px 24px', gap: 8 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          style={{
            color: '#666',
            borderColor: '#ddd',
            padding: '8px 24px',
            textTransform: 'none',
            borderRadius: 6
          }}
        >
          {cancelText || t('close') || 'Close'}
        </Button>

        {onConfirm && (
          <Button
            onClick={onConfirm}
            variant="contained"
            style={{
              backgroundColor: getConfirmButtonColor(),
              color: 'white',
              padding: '8px 24px',
              textTransform: 'none',
              borderRadius: 6,
              '&:hover': {
                backgroundColor: getConfirmButtonColor()
              }
            }}
          >
            {confirmText || 'Confirm'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
